import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryExplorer from './components/CategoryExplorer';
import ContentSections from './components/ContentSections';
import PillarArticles from './components/PillarArticles';
import ArticlePromo from './components/ArticlePromo';

export default function Home() {
  const { t } = useTranslation();

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: t('brand'),
    url: import.meta.env.VITE_SITE_URL,
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: t('brand'),
    url: import.meta.env.VITE_SITE_URL,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg',
  };

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <CategoryExplorer />
        <ContentSections />
        <PillarArticles />
        <ArticlePromo />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
    </div>
  );
}